import { connect } from 'react-redux'
import Details from './details'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../../stores/user/user.selectors'
import { leaveSchool } from '../../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { URLS } from 'pobble-components/dist/setup'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const school = user.teacher_type.school
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    title: school.title || '-',
    urn: school.urn || '-',
    isSchoolLeader: user.teacher_type.school_leader,
    schoolId: school.id,
    userId: user.id
  }
}

const mapDispatchToProps = dispatch => ({
  onRemove: (schoolId, userId) => {
    dispatch(leaveSchool(schoolId, userId))
      .then(() => (window.location = `${URLS.AUTH}/finish-signup`))
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Details)
